import { render } from "./HomeContact.html?vue&type=template&id=254c8a8a&scoped=true&ts=true"
import script from "./HomeContact.ts?vue&type=script&lang=ts"
export * from "./HomeContact.ts?vue&type=script&lang=ts"

import "./HomeContact.scss?vue&type=style&index=0&id=254c8a8a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254c8a8a"]])

export default __exports__